import React from 'react'
import styled from 'styled-components'

const PricingWrapper = styled.header`
  height: 160px;
  position: relative;
  text-align: center;
`

export const HappituGuidePrice = () => {
  return (
    <PricingWrapper>
      <h2>
        From <strong>$25</strong>/mo
      </h2>
      <p>
        Support your agents by taking them step-by-step through complex conversations with
        customers via dynamic scripting and contextual help topics.
      </p>
    </PricingWrapper>
  )
}

export const HappituVisionPrice = () => {
  return (
    <PricingWrapper>
      <h2>
        Starting at <strong>$95</strong>/mo
      </h2>
      <p>
        Start analyzing 100% of your customer interactions within minutes. No
        integrations, no hidden fees. Simple pay as you go pricing.
      </p>
    </PricingWrapper>
  )
}

export const HappituVisionEnterprisePrice = () => {
  return (
    <PricingWrapper>
      <h2>Enterprise</h2>
      <p>
        Start analyzing 100% of your customer interactions within minutes. No
        integrations, no hidden fees. Simple pay as you go pricing.
      </p>
    </PricingWrapper>
  )
}
